<template>
  <div class="card">
    <div class="media mt-0">
      <div class="media-body">
        <div class="row">
          <div class="col-lg-5">
            <div class="form-group">
              <label :for="'starts_at'" class="required">Starts at</label>
              <input type="text" :name="'starts_at'" class="form-control form-control-lg"
                :class="[{ 'is-invalid': errors.has('starts_at') }, 'inputStartsDate']"
                v-model="eventDate.starts_at" v-validate="'required|eventDateValidation:before,ends_at'"
                data-vv-as="Starts at" :ref="'starts_at'"
                :vid="'starts_at'" />
              <span v-show="errors.has('starts_at')" class="input-error">
                {{ errors.first('starts_at') }}
              </span>
            </div>
          </div>

          <div class="col-lg-5">
            <div class="form-group">
              <label :for="'ends_at'" class="required">Ends at</label>
              <input type="text" :name="'ends_at'" class="form-control form-control-lg inputDate"
                :class="[{ 'is-invalid': errors.has('ends_at') }, 'inputEndsDate']"
                v-model="eventDate.ends_at" data-vv-as="Ends at"
                v-validate="'required|eventDateValidation:after,starts_at'" />
              <span v-show="errors.has('ends_at')" class="input-error">
                {{ errors.first('ends_at') }}
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-5">
            <div class="form-group">
              <label :for="'sales_starts_at'" class="required">Sales start at</label>
              <input type="text" :name="'sales_starts_at'" class="form-control form-control-lg inputDate"
                :class="[{ 'is-invalid': errors.has('sales_starts_at') }, 'inputSalesStartsDate']"
                v-model="eventDate.sales_starts_at" data-vv-as="Sales starts at"
                v-validate="'required|eventDateValidation:before,sales_ends_at'" />
              <span v-show="errors.has('sales_starts_at')" class="input-error">
                {{ errors.first('sales_starts_at') }}
              </span>
            </div>
          </div>
         <div class="col-lg-5">
            <div class="form-group">
              <label :for="'sales_ends_at'" class="required">Sales end at</label>
              <input type="text" :name="'sales_ends_at'" class="form-control form-control-lg inputDate"
                     :class="[{ 'is-invalid': errors.has('sales_ends_at') }, 'inputSalesEndsDate']"
                     v-model="eventDate.sales_ends_at" data-vv-as="Sales ends at"
                     v-validate="'required|eventDateValidation:after,sales_starts_at|eventDateValidation:before,ends_at'" />
              <span v-show="errors.has('sales_ends_at')" class="input-error">
                {{ errors.first('sales_ends_at') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

export default {
  name: 'EventDateForm',
  inject: ['$validator'],
  props: {
    eventDate: {
      required: true,
      type: Object
    },
    disabled: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {}
  },
  created () {
    let self = this

    dayjs.extend(isoWeek)
    this.$validator.extend('eventDateValidation', {
      getMessage (_field, [_validation, _otherField]) {
        return `${_field} must be ${_validation} ${_otherField.replace(/_/g, ' ')}`
      },
      validate (_value, [_validation, _otherField]) {
        let firstDate = new Date(_value.replace(/-/g, '/'))
        let secondDate = new Date(self.eventDate[_otherField].replace(/-/g, '/'))
        let result = false

        if (_validation === 'before') {
          result = firstDate < secondDate
        } else {
          result = firstDate > secondDate
        }

        if (result) self.errors.remove(_otherField)
        return result
      }
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.eventDate.starts_at = this.defaultStartsAt()
      this.eventDate.ends_at = this.defaultEndsAt()
      this.eventDate.sales_starts_at = this.defaultSalesStartAt()
      this.eventDate.sales_ends_at = this.defaultSalesEndsAt()

      let startsDate = this.getFlatPickrInstance('.inputStartsDate', this.eventDate.starts_at)
      let endsDate = this.getFlatPickrInstance('.inputEndsDate', this.eventDate.ends_at)
      let salesStartsDate = this.getFlatPickrInstance('.inputSalesStartsDate', this.eventDate.sales_starts_at)
      let salesEndsDate = this.getFlatPickrInstance('.inputSalesEndsDate', this.eventDate.sales_ends_at)

      if (this.disabled) {
        startsDate.input.setAttribute('disabled', 'disabled')
        endsDate.input.setAttribute('disabled', 'disabled')
        salesStartsDate.input.setAttribute('disabled', 'disabled')
      } else {
        startsDate.input.removeAttribute('readOnly')
        endsDate.input.removeAttribute('readOnly')
        salesStartsDate.input.removeAttribute('readOnly')
        salesEndsDate.input.removeAttribute('readOnly')
      }
    })
  },
  methods: {
    getFlatPickrInstance (className, date) {
      return flatpickr(className, {
        enableTime: true,
        defaultDate: date,
        dateFormat: 'Y-m-d H:i:S',
        onOpen: [
          function (selectedDates, dateStr, instance) {
            instance.setDate(new Date(dateStr))
            instance.jumpToDate(new Date(dateStr), false)
          }
        ]
      })
    },
    someSaturday () {
      return dayjs().add(35, 'day').isoWeekday(6)
    },
    basicFutureDate (hour, minute) {
      return this.someSaturday().hour(hour).minute(minute)
    },
    defaultStartsAt () {
      return this.inferDate('starts_at', () => this.basicFutureDate(19, 0))
    },
    defaultEndsAt () {
      return this.inferDate('ends_at', () => this.basicFutureDate(22, 0))
    },
    defaultSalesStartAt () {
      return this.inferDate('sales_starts_at', () => dayjs().hour(24).minute(0))
    },
    defaultSalesEndsAt () {
      return this.inferDate('sales_ends_at', () => this.basicFutureDate(18, 0))
    },
    inferDate (attr, callback) {
      const date = this.eventDate[attr]

      if (date) {
        let x = date.split(' ')

        if (x.length === 3) {
          x.pop()
        }

        return dayjs(x.join(' ')).format('YYYY-MM-DD HH:mm')
      } else {
        return callback().format('YYYY-MM-DD HH:mm')
      }
    }
  }
}
</script>
